/* eslint-disable @typescript-eslint/no-explicit-any */
import { useParams } from "react-router-dom";
import AppHeader from "../components/appheader";
import "./question.scss";
import LoadError from "../components/error";
import { SetStateAction, useEffect, useRef, useState } from "react";
import { ApiEndpoint, BrandColors } from "../components/utils";
import axios from "axios";
import { useQuery } from "react-query";
import Loader from "../components/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Alert,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Snackbar,
} from "@mui/material";
import {
  BrandButton,
  BrandButtonGray,
  BrandButtonWhite,
} from "../components/form/buttons";
import { BrandInput } from "../components/form/inputs";
import { useNavigate } from "react-router-dom";
import Calculator from "../components/form/calculator";
import FooterQuestionIndex from "../components/footerQuestionIndex";
import NetworkError from "../components/networkError";
import {
  getAppInfo,
  getCurrentSectionandQuestion,
  getUserInfo,
  updateCurrentExamData,
} from "../components/user";
import Resources from "../components/form/resources";

interface QuestionDefinition {
  success: boolean;
  questionId: string;
  type: string;
  description: any;
  options: string[];
  isMath: boolean;
  questions: any;
  isPassage?: boolean;
  mathImage?: string;
  passage: any;
}

const Question = () => {
  const userData = getUserInfo();
  const config = getAppInfo()?.configData;
  const { questionid } = useParams();
  const [questionData, setQuestionData] = useState<QuestionDefinition>();
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [radioOption, setRadioOption] = useState<null | string>();
  const [snackError, setSnackError] = useState(false);
  const [snackSaved, setSnackSaved] = useState(false);
  const vertical = "bottom";
  const horizontal = "center";
  const [errorMsg, setErrorMsg] = useState("");
  const [fillInValue, setFillinValue] = useState("");
  const previousAnswer = useRef<string>("");
  const answered = useRef(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showFooterModal, setShowFooterModal] = useState(false);
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { currentSectionId, currentQuestionId } =
    getCurrentSectionandQuestion();
  let examData = getAppInfo()?.currentExamData;
  const fetchEnabled = useRef(false);
  const allowedChars = new RegExp(/^[-]?[0-9./]*$/gi);

  const { isLoading, error, refetch } = useQuery(
    "questionPageData",
    async () => {
      if (questionid) {
        const resp = await axios.post(
          ApiEndpoint + "wp-json/satapp-api/v1/getExamQuestion",
          {
            token: userData?.token,
            exam_id: examData?.examId,
            questionId: questionid,
          }
        );
        if (!resp || !resp.data.success) {
          setHasError(true);
          return;
        }
        examData = getAppInfo()?.currentExamData;
        setQuestionData(resp.data);
      } else {
        return null;
      }
    },
    {
      enabled: fetchEnabled.current,
    }
  );

  const getCurrentQuestionIndex = (): number => {
    let currIndex = -1;
    examData?.examAnswers[currentSectionId as number].questions.forEach(
      (item, index) => {
        if (item.questionId === currentQuestionId) {
          currIndex = index;
        }
      }
    );
    return currIndex;
  };

  const submitAnswer = () => {
    setLoading(true);
    if (questionData?.type === "multiple") {
      if (answered.current !== false && !radioOption) {
        gotoNextQuestion();
        return;
      }
      if (radioOption) {
        updateUserQuestionData(parseInt(radioOption));
        gotoNextQuestion();
      } else {
        setLoading(false);
        setErrorMsg(
          "Please select an answer before submitting or skip this question."
        );
        setSnackError(true);
      }
    } else if (questionData?.type === "input") {
      if (answered.current !== false && fillInValue !== "") {
        updateUserQuestionData(fillInValue, true);
        gotoNextQuestion();
        return;
      }
      if (fillInValue === "") {
        setLoading(false);
        setErrorMsg(
          "Please fill in an answer before submitting or skip this question."
        );
        setSnackError(true);
        return;
      }
    }
  };

  const gotoNextQuestion = async () => {
    setLoading(true);
    const currIndex = getCurrentQuestionIndex();
    const curSection =
      examData?.examAnswers[currentSectionId as number].questions;
    const len = curSection ? curSection?.length : 0;
    if (currIndex >= len - 1) {
      setLoading(false);
      navigate("/section-complete", { replace: true });
    } else {
      const nextQId =
        examData?.examAnswers[currentSectionId as number].questions[
          currIndex + 1
        ].questionId;
      // setLoading(false);
      setSnackSaved(true);
      gotoQuestion(nextQId as string);
    }
  };

  const checkIfAnswered = () => {
    setFillinValue("");
    const tempExamData = getAppInfo()?.currentExamData;
    const currIndex = getCurrentQuestionIndex();

    let currQuestionValue =
      tempExamData?.examAnswers[currentSectionId as number].questions[currIndex]
        .value;

    currQuestionValue = currQuestionValue
      ? currQuestionValue.toString()
      : currQuestionValue;

    previousAnswer.current = currQuestionValue as string;

    if (currQuestionValue !== null) {
      answered.current = true;
      if (questionData?.type === "input") {
        setFillinValue(currQuestionValue as string);
      } else {
        questionData?.options.forEach((item, index) => {
          if (item === currQuestionValue) {
            setRadioOption(index.toString() as string);
            previousAnswer.current = index.toString();
          }
        });
      }
    } else {
      answered.current = false;
    }
    setLoading(false);
  };

  const updateUserQuestionData = async (val: any, bypass = false) => {
    if (!bypass) {
      let convertedval = "";
      if (examData) {
        questionData?.options.forEach((item, index) => {
          if (index === parseInt(val)) {
            convertedval = questionData?.options[index];
          }
        });
        examData.examAnswers[currentSectionId as number].questions[
          getCurrentQuestionIndex()
        ].value = convertedval;
        updateCurrentExamData(examData.examId as number, {
          examAnswers: examData.examAnswers,
        });
      }
    } else {
      if (examData) {
        examData.examAnswers[currentSectionId as number].questions[
          getCurrentQuestionIndex()
        ].value = val;
        updateCurrentExamData(examData.examId as number, {
          examAnswers: examData.examAnswers,
        });
      }
    }
    const resp = await axios.post(
      ApiEndpoint + "wp-json/satapp-api/v1/submitAnswer",
      {
        token: userData?.token,
        exam_id: examData?.examId,
        questionId: questionid,
        answer: val,
      }
    );

    setLoading(false);
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }
  };

  const closeSnack = () => {
    setSnackError(false);
    setSnackSaved(false);
  };

  const resetQuestion = () => {
    setFillinValue("");
    previousAnswer.current = "";
    setRadioOption(null);
  };

  const gotoQuestion = (questionId: string) => {
    if( questionId === currentQuestionId){
      return
    }
    setLoading(true);
    resetQuestion();
    updateCurrentExamData(examData?.examId as number, {
      lastQuestionAnswered: questionId,
    });
    navigate("/question/" + questionId, { replace: true });
  };

  const gotoPreviousQuestion = () => {
    const currIndex = getCurrentQuestionIndex();
    const currQuestion =
      examData?.examAnswers[currentSectionId as number].questions[
        currIndex - 1
      ];
    gotoQuestion(currQuestion?.questionId as string);
  };

  const checkInputAnswer = (val: SetStateAction<string>) => {
    const inputVal = val as string;
    const checkValid = inputVal.match(allowedChars);
    if (checkValid || inputVal === "") {
      setFillinValue(val);
      answered.current = true;
    }
  };

  useEffect(() => {
    // setLoading(false);
    if (!questionData || !userData) return;
    resetQuestion();
    checkIfAnswered();
  }, [questionData]);

  useEffect(() => {
    if (questionid) {
      const currentSection =
        examData?.examAnswers[currentSectionId as number].questions;
      setTotalQuestions(currentSection ? currentSection.length : 0);
      refetch();
    }
  }, [questionid, refetch]);

  const updateSubmitEnabledBtn = (isEnabled: boolean) => {
    setSubmitEnabled(isEnabled);
  };

  if (!userData || !questionid) return <LoadError />;
  if (isLoading || loading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <>
      <div className="questionPage">
        <div>
          <AppHeader
            timer={true}
            checkTimer={true}
            exposeTimer={updateSubmitEnabledBtn}
          />
          <div className="questionHeader">
            <h1>
              {config?.questionSections[currentSectionId as number].includes(
                "2a"
              ) ||
              config?.questionSections[currentSectionId as number].includes(
                "2b"
              )
                ? config?.questionSections[
                    currentSectionId as number
                  ].substring(
                    0,
                    config.questionSections[currentSectionId as number].length -
                      1
                  )
                : config?.questionSections[currentSectionId as number]}
            </h1>
            <p>
              Question {getCurrentQuestionIndex() + 1} of {totalQuestions}
            </p>
          </div>
          <div
            className={
              questionData?.isPassage
                ? "questionContent passage"
                : "questionContent"
            }
          >
            {questionData?.isPassage && (
              <div
                className="passageText"
                dangerouslySetInnerHTML={{
                  __html: questionData?.passage,
                }}
              />
            )}
            <div className="answerWrapper">
              <div className="questionHolder">
                <div className="questionCount">
                  {getCurrentQuestionIndex() + 1})
                </div>
                {questionData?.isMath && questionData.mathImage ? (
                  <div
                    className="questionText"
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{
                      __html: `<div><img src="${questionData?.mathImage}" /></div>${questionData?.description}`,
                    }}
                  />
                ) : (
                  <div
                    className="questionText"
                    dangerouslySetInnerHTML={{
                      __html: questionData?.description,
                    }}
                  />
                )}
              </div>

              <div className="questionAnswersHolder">
                {questionData?.type === "multiple" && (
                  <div className="multipleAnswers">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="question-options"
                        name="radio-options"
                        key="radio-options"
                      >
                        {questionData?.options.map((item: any, index: any) => {
                          return (
                            <>
                              <FormControlLabel
                                key={index}
                                value={index}
                                control={
                                  <Radio
                                    sx={{
                                      color: BrandColors.brandGreen,
                                      "&.Mui-checked": {
                                        color: BrandColors.brandGreen,
                                      },
                                    }}
                                    onChange={(evt) => {
                                      previousAnswer.current = evt.target.value;
                                      setRadioOption(evt.target.value);
                                    }}
                                    checked={
                                      // eslint-disable-next-line eqeqeq
                                      index === parseInt(previousAnswer.current) &&
                                      previousAnswer.current !== null
                                        ? true
                                        : false
                                    }
                                  />
                                }
                                label={item}
                              />
                            </>
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </div>
                )}
                {questionData?.type === "input" && (
                  <div className="inputHolder">
                    <BrandInput
                      onChange={(evt) => {
                        checkInputAnswer(evt.target.value);
                      }}
                      id="filled-basic"
                      label="Answer Here"
                      variant="filled"
                      value={fillInValue}
                    />
                  </div>
                )}
              </div>

              <div style={{ display: "flex" }}>
                <div className="submitAnswerHolder">
                  <BrandButton onClick={submitAnswer} disabled={!submitEnabled}>
                    SUBMIT ANSWER
                  </BrandButton>
                  <BrandButtonWhite
                    onClick={gotoNextQuestion}
                    style={{ marginTop: "10px" }}
                    disabled={!submitEnabled}
                  >
                    SKIP QUESTION
                  </BrandButtonWhite>
                </div>
              </div>
            </div>
          </div>

          <Snackbar
            open={snackError}
            autoHideDuration={6000}
            onClose={closeSnack}
            anchorOrigin={{ vertical, horizontal }}
          >
            <Alert severity="error">{errorMsg}</Alert>
          </Snackbar>
          <Snackbar
            open={snackSaved}
            autoHideDuration={2000}
            onClose={closeSnack}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          >
            <Alert severity="success">Answer Saved</Alert>
          </Snackbar>
        </div>
        {questionData?.isMath && <Calculator />}
        {(currentSectionId === 3 ||
          currentSectionId === 4 ||
          currentSectionId === 5) && <Resources />}
      </div>
      <div className="questionNav">
        <div className="holder">
          {showFooterModal && (
            <FooterQuestionIndex
              data={examData?.examAnswers[currentSectionId as number].questions}
              onChange={gotoQuestion}
              onToggle={setShowFooterModal}
            />
          )}
          <div className="nav-buttons">
            <BrandButtonGray
              style={{ marginTop: "10px" }}
              onClick={() => setShowFooterModal(!showFooterModal)}
            >
              Go to Specific Question
            </BrandButtonGray>
            {getCurrentQuestionIndex() > 0 && (
              <BrandButton
                onClick={gotoPreviousQuestion}
                style={{ marginTop: "10px" }}
              >
                <FontAwesomeIcon icon={faChevronLeft} /> Previous QUESTION
              </BrandButton>
            )}
          </div>
        </div>
      </div>
      <NetworkError open={hasError} />
    </>
  );
};

export default Question;
